import { useLocation, useOutletContext, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import useNavigationMatch from 'modules/core/hooks/useNavigationMatch'

import { RouteContextParams } from 'modules/expenses/lib/RouteContextParams'
import { isMyExpensesSection } from 'modules/expenses/lib/common'

type Tab = 'expenses' | 'groups'

export const useExpensesNavigation = () => {
  const { pathname } = useLocation()
  const { groupId } = useParams()
  const { navigation: rootNavigation } = useNavigation()
  const context = useOutletContext<RouteContextParams | null>()

  const section = isMyExpensesSection(context?.section) ? 'myExpenses' : 'expenses'
  const sectionNavigation = rootNavigation[section]

  const matches = useNavigationMatch(rootNavigation, pathname)
  const tab: Tab = matches.some(({ path }) => path === 'groups') ? 'groups' : 'expenses'

  const expensableDetail = (id: string | number) =>
    groupId
      ? sectionNavigation.groups.id.expenseId.fullPath({ expense_id: id, groupId })
      : sectionNavigation.list.expenses.expenseId.fullPath({ expense_id: id })

  const groupDetail = (id: string | number) => sectionNavigation.groups.id.fullPath({ groupId: id })

  const newExpense = () =>
    groupId
      ? rootNavigation.myExpenses.groups.id.new.fullPath({ groupId })
      : rootNavigation.myExpenses.list[tab].new.fullPath()

  const newExpenseOcr = () =>
    groupId
      ? rootNavigation.myExpenses.groups.id.newExpenseOcr.fullPath({ groupId })
      : rootNavigation.myExpenses.list[tab].newExpenseOcr.fullPath()

  const newMileage = () =>
    groupId
      ? rootNavigation.myExpenses.groups.id.newMileage.fullPath({ groupId })
      : rootNavigation.myExpenses.list[tab].newMileage.fullPath()

  const newPerDiem = () =>
    groupId
      ? rootNavigation.myExpenses.groups.id.newPerDiem.fullPath({ groupId })
      : rootNavigation.myExpenses.list[tab].newPerDiem.fullPath()

  const newGroup = () => rootNavigation.myExpenses.list[tab].newGroup.fullPath()

  const getExpensesFormBackPath = () => {
    if (groupId) {
      return rootNavigation.myExpenses.groups.id.fullPath({ groupId })
    } else if (tab === 'groups') {
      return rootNavigation.myExpenses.list.groups.fullPath()
    } else {
      return rootNavigation.myExpenses.list.expenses.fullPath()
    }
  }

  return {
    tab,
    navigation: {
      ...sectionNavigation,
      list: sectionNavigation.list[tab],
      exporter: sectionNavigation.list.expenses.exporter,
      cards: rootNavigation.myCards,
      helpers: {
        expensableDetail,
        groupDetail,
        newExpense,
        newExpenseOcr,
        newMileage,
        newPerDiem,
        newGroup,
        getExpensesFormBackPath,
      },
    },
  }
}
